import { runKbAiHelpFlow } from "./runKbAiHelpFlow";

export function useKbAiHelpWorkflow(params: any) {
  const { state, capabilities, context } = params;
  async function runAiHelp(mode: "title_only" | "metadata_only" | "full" | "stop_and_draft" = "full") {
    await runKbAiHelpFlow({
      mode,
      articleContent: state.articleContent,
      aiPurpose: state.aiPurpose,
      aiAudienceHint: state.aiAudienceHint,
      aiScopeHint: state.aiScopeHint,
      aiDocTypeHint: state.aiDocTypeHint,
      aiSourceKind: state.aiSourceKind,
      articleSlug: state.articleSlug,
      articleTitle: state.articleTitle,
      defaultArticleTitle: context.defaultArticleTitle,
      articleDocType: state.articleDocType,
      articleScope: state.articleScope,
      articleTagsInput: state.articleTagsInput,
      aiQuestionAnswers: state.aiQuestionAnswers,
      aiResolvedFacts: state.aiResolvedFacts,
      preserveOriginalBody: state.preserveOriginalBody,
      aiUpdateTitle: state.aiUpdateTitle,
      aiUpdateMetadata: state.aiUpdateMetadata,
      canManageManufacturerScope: capabilities.canManageManufacturerScope,
      canManageAppScope: capabilities.canManageAppScope,
      canPublishKb: capabilities.canPublishKb,
      organizationDisplayName: context.kbOrgDisplayName,
      mergeAiQuestions: context.mergeAiQuestions,
      showNote: context.showNote,
      showAiFeedback: context.showAiFeedback,
      setAiBusy: state.setAiBusy,
      setArticleTitle: state.setArticleTitle,
      setArticleAudience: state.setArticleAudience,
      setArticleScope: state.setArticleScope,
      setArticleDocType: state.setArticleDocType,
      setArticleStatus: state.setArticleStatus,
      setArticleTagsInput: state.setArticleTagsInput,
      setAiGeneratedNotes: state.setAiGeneratedNotes,
      setAiResolvedFacts: state.setAiResolvedFacts,
      setAiPlacementSummary: state.setAiPlacementSummary,
      setAiSuggestedAction: state.setAiSuggestedAction,
      setAiTopicComplexity: state.setAiTopicComplexity,
      setAiRecommendedDocCount: state.setAiRecommendedDocCount,
      setAiStopReason: state.setAiStopReason,
      setAiFollowOnDocs: state.setAiFollowOnDocs,
      setAiKbGapCandidates: state.setAiKbGapCandidates,
      setAiArticleLinkSuggestions: state.setAiArticleLinkSuggestions,
      setAiRelatedArticles: state.setAiRelatedArticles,
      setAiBodyDraft: state.setAiBodyDraft,
      setAiBodyGenerationNotes: state.setAiBodyGenerationNotes,
      setAiLinksOpen: state.setAiLinksOpen,
      setAppliedSuggestion: state.setAppliedSuggestion,
    });
  }
  return { runAiHelp };
}
